import attackerBytecodeRaw from "../../contract/attacker_compiled?raw";
import attackerNoParamsBytecodeRaw from "../../contract/attacker_no_params?raw";
import tokenBytecodeRaw from "../../contract/token_compiled?raw";
import vpoolBytecodeRaw from "../../contract/vpool_compilled?raw";

import attackerSource from "../../contract/attacker.sol?raw";
import tokenSource from "../../contract/token.sol?raw";
import vpoolSource from "../../contract/vpool.sol?raw";

export type MinimalArtifact = {
  contractName: string;
  abi: readonly unknown[];
  bytecode: `0x${string}`;
};

function as0x(hex: string): `0x${string}` {
  const h = hex.trim().replace(/^0x/i, "");
  return (`0x${h}`) as `0x${string}`;
}

// Minimal ABIs: only what the dapp needs.
export const DummyTokenArtifact: MinimalArtifact = {
  contractName: "DummyToken",
  abi: [
    {
      type: "constructor",
      inputs: [
        { name: "name", type: "string" },
        { name: "symbol", type: "string" }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "transfer",
      inputs: [
        { name: "to", type: "address" },
        { name: "amount", type: "uint256" }
      ],
      outputs: [{ name: "", type: "bool" }],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "faucet",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable"
    }
  ] as const,
  bytecode: as0x(tokenBytecodeRaw)
};

export const VulnerableLenderPoolArtifact: MinimalArtifact = {
  contractName: "VulnerableLenderPool",
  abi: [
    {
      type: "constructor",
      inputs: [{ name: "tokenAddress", type: "address" }],
      stateMutability: "nonpayable"
    }
  ] as const,
  bytecode: as0x(vpoolBytecodeRaw)
};

export const AttackerArtifact: MinimalArtifact = {
  contractName: "Attacker",
  abi: [
    {
      type: "constructor",
      inputs: [
        { name: "tokenAddress", type: "address" },
        { name: "poolAddress", type: "address" }
      ],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "attack",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable"
    },
    {
      type: "function",
      name: "drainFunds",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable"
    }
  ] as const,
  bytecode: as0x(attackerBytecodeRaw)
};

export const AttackerNoParamsArtifact: MinimalArtifact = {
  contractName: "AttackerNoParams",
  abi: [
    {
      type: "function",
      name: "attack",
      inputs: [],
      outputs: [],
      stateMutability: "nonpayable"
    }
  ] as const,
  bytecode: as0x(attackerNoParamsBytecodeRaw)
};

export const ContractSources = {
  token: tokenSource,
  vpool: vpoolSource,
  attacker: attackerSource
} as const;


